export const environment = {
  production: true,
  name: 'production',
  apiUrl: 'api.dev-modeler.nicosworld.eu',
  timeCloseModal: 2000,
  take: 1,
};
